/**
 * /cart 用：配送希望日の範囲ガード
 * 要件：
 * - 商品タイトルに「ラズベリーガトーショコラ」が1つでも含まれていれば対象
 * - 配送希望日は 2025/12/19 ～ 2025/12/26 のみ（両端含む）
 * - レジに進むクリック時に検証し、NGならモーダルを出して遷移を止める
 * - 「閉じる」で値は変更しない（ご指定どおり）
 * - jQuery 不使用、Alpine/Ajax のDOM差し替えに耐える
 */

(function () {
  'use strict';

  // --- 設定値（年次で差し替えやすいよう定数化） -------------------------
  const PAGE_OK = location.pathname.startsWith('/cart');
  if (!PAGE_OK) return;

  const TARGET_SUBSTR = 'ラズベリーガトーショコラ'; // 部分一致
  // JST（UTC+9）として境界を厳密比較
  const RANGE_MIN_JST = new Date('2025-12-19T00:00:00+09:00').getTime();
  const RANGE_MAX_JST = new Date('2025-12-26T23:59:59+09:00').getTime();

  const SHIPPING_INPUT_SELECTOR = 'input[name="attributes[配送希望日]"]';
  const TITLE_LINK_SELECTOR = 'a[x-text="item.title"]'; // 第一候補
  // 念のためのフォールバック（テーマ差異に耐える）
  const TITLE_FALLBACK_SELECTOR = 'a.cart__product-title, .cart__item a[href*="/products/"]';

  const CHECKOUT_BTN_SELECTOR = '#regi-btn input[name="checkout"]';

  // --- ユーティリティ --------------------------------------------------------
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function extractDateJST(value) {
    // 期待フォーマット例: "2025/12/19(金)" / "2025/12/19"
    // まず YYYY/MM/DD を抜き出す（曜日は無視）
    if (!value) return null;
    const m = value.match(/(\d{4})[\/\-](\d{1,2})[\/\-](\d{1,2})/);
    if (!m) return null;
    const [ , y, mo, d ] = m.map(Number);
    // JSTの00:00に固定
    const iso = `${String(y).padStart(4,'0')}-${String(mo).padStart(2,'0')}-${String(d).padStart(2,'0')}T00:00:00+09:00`;
    const t = new Date(iso).getTime();
    return Number.isNaN(t) ? null : t;
  }

  function hasTargetProduct() {
    const nodes = $$(TITLE_LINK_SELECTOR);
    const list = nodes.length ? nodes : $$(TITLE_FALLBACK_SELECTOR);
    return list.some(el => (el.textContent || '').includes(TARGET_SUBSTR));
  }

  function isShippingDateInRange() {
    const input = $(SHIPPING_INPUT_SELECTOR);
    if (!input) return false; // 見つからなければ NG 扱い（案内のため）
    const v = (input.value || '').trim();
    // 未選択と見なす典型値（必要なら増やせる）
    if (v === '' || v === 'カレンダーを開く') return false;

    const t = extractDateJST(v);
    if (t === null) return false;
    return (t >= RANGE_MIN_JST && t <= RANGE_MAX_JST);
  }

  // --- モーダル制御（フォーカストラップ & Esc & 背面スクロール固定） -----
  const modal = $('#js-cdg-modal');
  const btnClose = $('#js-cdg-close');
  let lastFocused = null;

  function openModal() {
    if (!modal) return;
    lastFocused = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('u-body-fixed');
    // フォーカス移動
    btnClose?.focus();

    // キーハンドラ
    document.addEventListener('keydown', onKeydownTrap, true);
    modal.addEventListener('click', onOverlayClick, true);
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('u-body-fixed');
    document.removeEventListener('keydown', onKeydownTrap, true);
    modal.removeEventListener('click', onOverlayClick, true);
    // 元のフォーカスへ
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  function onOverlayClick(e) {
    const isOverlay = e.target && e.target.hasAttribute && e.target.hasAttribute('data-cdg-overlay');
    if (isOverlay) {
      closeModal();
    }
  }

  function onKeydownTrap(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal();
      return;
    }
    if (e.key === 'Tab') {
      // 単一ボタンのため簡易トラップ（複数アクションに拡張可）
      const focusables = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      const f = Array.from(focusables).filter(el => !el.hasAttribute('disabled') && el.tabIndex !== -1);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
  }

  btnClose?.addEventListener('click', closeModal);

  // --- 検証 & ハンドラ -------------------------------------------------------
  function shouldBlockCheckout() {
    // ① 対象商品が1つでもある
    const target = hasTargetProduct();
    if (!target) return false; // 対象商品が無いなら制限なし

    // ② 配送希望日が範囲内（未選択もNG）
    const ok = isShippingDateInRange();
    return !ok; // 範囲外/未選択ならブロック
  }

  function attachCheckoutGuard() {
    const btn = $(CHECKOUT_BTN_SELECTOR);
    if (!btn) return;
    if (btn.dataset.cdgBound === '1') return; // 二重バインド防止

    btn.addEventListener('click', function onCheckoutClick(e) {
      if (shouldBlockCheckout()) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      }
    }, true);

    btn.dataset.cdgBound = '1';
  }

  // 初回
  attachCheckoutGuard();

  // Alpine/Ajaxで差し替わる可能性に対応（軽量デバウンス付き）
  let moTimer = null;
  const observer = new MutationObserver(() => {
    if (moTimer) cancelAnimationFrame(moTimer);
    moTimer = requestAnimationFrame(() => {
      attachCheckoutGuard();
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
